export default __webpack_public_path__ + "static/media/Image5.9b433910.png";